// extracted by mini-css-extract-plugin
export default {"notificationListContainer":"Notifications_notificationListContainer__QvBg3"};